import React, { useState } from "react";
import "../../css/hero.css";
import { useNavigate } from "react-router-dom"; import mobileBanner from "../../image/banner.png";

function Mobile_Hero({ setShowModal }) {
  const [result, setResult] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    const dataObj = Object.fromEntries(formData.entries());
    dataObj.subject = "New Enquiry from Mobile Hero Section";

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataObj)
      });

      const data = await response.json();

      if (data.success) {
        navigate("/thank-you");
        event.target.reset();
      } else {
        console.log("Error", data);
        setResult("Something went wrong while submitting your enquiry. Please try again.");
      }
    } catch (error) {
      setResult("Something went wrong while submitting your enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="d-block d-md-none pt-0 pb-4">
      {/* 1. Mobile Banner Image at the very top */}
      <div className="text-center w-100">
        <img src={mobileBanner} alt="Hero Banner" className="img-fluid shadow-sm w-100" style={{ height: "230px", objectFit: "cover" }} />
      </div>

      {/* 2. Hero Form placed right below the banner */}
      <div className="container mt-4">
        <div className="hero-form-card position-relative p-4 bg-white text-dark rounded-4 shadow">
          <div className="form-badge position-absolute bg-orange text-white px-3 py-1 rounded-pill small fw-bold">
            APPLY NOW
          </div>

          <h3 className="form-heading text-primary-dark fw-bold mb-1 mt-2">
            Apply for PCD Pharma Franchise
          </h3>
          <p className="text-muted small mb-3">(Do not send Job Queries)</p>

          <form className="hero-form" onSubmit={onSubmit}>
            <div className="mb-3">
              <input type="text" name="name" className="form-control" placeholder="Your Name*" required />
            </div>
            <div className="mb-3">
              <input type="email" name="email" className="form-control" placeholder="Email*" pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" title="Please enter a valid email address" required />
            </div>
            <div className="mb-3">
              <input type="tel" name="phone" className="form-control" placeholder="Phone Number*" pattern="[0-9]{10}" maxLength="10" minLength="10" title="Please enter a valid 10-digit phone number" required />
            </div>
            <div className="mb-3">
              <input type="text" name="city" className="form-control" placeholder="Your City*" required />
            </div>
            <div className="mb-4">
              <textarea name="message" className="form-control" rows="2" placeholder="Message"></textarea>
            </div>
            <button type="submit" disabled={isSubmitting} className="btn px-4 py-2 text-white border-0 fw-bold rounded-2 form-submit-btn w-100 mb-2">
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
            {result && <div className="text-center small mt-2 fw-bold text-danger">{result}</div>}
          </form>
        </div>
      </div>
    </section>
  );
}

export default Mobile_Hero;
